import React from 'react';
import GoogleMapReact from 'google-map-react';
import { isEmpty, cloneDeep } from 'lodash';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';

import ACButton from '../../atoms/ACButton';
import ACMedia from '../../atoms/ACMedia';
import ACSelect from '../../atoms/ACSelect';

import { getDefaultPOI } from '../../common/providers';
import { getMediaForUIName, getLatestMedia } from '../../common/global';

import styles from './SetPOI.module.scss';

const AnyReactComponent = ({ text }) => {
  return (
    <div
      style={{
        width: '20px',
        padding: '10px',
        borderRadius: '50%',
        background: '#52A8EF',
        color: 'white',
      }}
    >
      {text}
    </div>
  );
};

export default class SetPOI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      poi: getDefaultPOI(),
      latLng: {},
    };

    this.onChangePOIText = this.onChangePOIText.bind(this);
    this.onChangeAddress = this.onChangeAddress.bind(this);
    this.onSavePOI = this.onSavePOI.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.poi) {
      const poi = nextProps.poi;
      const address = poi.where ? (poi.where.address ? poi.where.address : '') : '';

      const medias = poi.medias || [];
      let media = poi.media || { type: 'image', url: '' };
      poi.media = getLatestMedia(medias, media);
      this.setState({
        poi,
        latLng: {},
      });
      this.setInternalLatLon(address);
    }
  }

  componentDidUpdate(prevProps) {
    const { media = {} } = this.props;
    if (!isEmpty(media) && media !== prevProps.media) {
      this.updateMedia(media);
    }
  }

  updateMedia(media) {
    const { poi = {} } = cloneDeep(this.state);
    const { name } = media;
    switch (name) {
      case 'poiMedia':
        const poiMedia = poi.media || { type: 'image', url: '' };
        poiMedia.url = media.url;
        poi.media = poiMedia;
        this.setState({ poi });
        break;
      default:
        break;
    }
  }

  onChangeCategory = (name, category) => {
    if (isEmpty(category)) return null;
    const { value = '' } = category;
    let { poi } = this.state;

    poi[name] = value;

    this.setState({
      poi,
    });
  };

  onChangePOIText(key, event) {
    let poi = this.state.poi;
    const value = event.target.value;

    poi[key] = value;

    this.setState({
      poi,
    });
  }

  onChangeAddress(value) {
    let poi = this.state.poi;

    if (!poi.where) poi.where = {};
    poi.where.address = value;

    this.setState({
      poi,
    });
  }

  onUploadPOIMedia = e => {
    if (!e.target) return null;
    const { files = [] } = e.target;
    const mediaFor = {
      ui: getMediaForUIName().poi,
      name: 'poiMedia',
      s3FolderName: 'generic',
    };
    const { uploadMediaFunc } = this.props;
    const { poi } = this.state;
    const { media } = poi;
    uploadMediaFunc(mediaFor, media.type || '', files[0] || {});
  };

  onSavePOI() {
    let poi = this.state.poi;

    this.props.onSavePOIFunc(poi);
    this.props.onCloseFunc();
  }

  setInternalLatLon(address) {
    if (!address) return;
    let latLng = {
      lat: 0,
      lon: 0,
    };
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(ll => {
        latLng.lat = ll.lat;
        latLng.lon = ll.lng;
        this.setState({ latLng });
      })
      .catch(error => console.error('Error', error));
  }

  renderMap(latLon) {
    // console.log("latLon", latLon);
    if (!isEmpty(latLon)) {
      return (
        <div
          style={{
            height: '200px',
            width: '100%',
            textAlign: 'center',
          }}
        >
          <GoogleMapReact
            bootstrapURLKeys={{ key: 'AIzaSyA1TBd-lUkpnOU2ncV0YLRibIZXC3CYAF0' }}
            defaultCenter={{
              lat: latLon.lat,
              lng: latLon.lon,
            }}
            defaultZoom={13}
          >
            <AnyReactComponent lat={latLon.lat} lng={latLon.lon} text="POI" />
          </GoogleMapReact>
        </div>
      );
    }
  }

  renderCategories() {
    const { poi = {}, categories = [], dummyCategoryName } = this.props;
    const { category = '' } = poi;

    if (isEmpty(categories)) return <div />;

    const dummyCategoryNameIndex = categories.findIndex(cat => {
      return cat === dummyCategoryName;
    });
    if (dummyCategoryNameIndex >= 0) categories.splice(dummyCategoryNameIndex, 1);

    return (
      <div className={styles.products}>
        <span
          style={{
            fontSize: '14px',
          }}
        >
          Category
        </span>
        <ACSelect
          name="category"
          showLabel={false}
          options={categories}
          option={category}
          optionLabel="label"
          optionValue="value"
          onChangeFunc={this.onChangeCategory}
        />
      </div>
    );
  }

  render() {
    const { poi } = cloneDeep(this.state);
    const {provider} = this.props;
    const { media = { type: 'image', url: '' } } = poi;
    if (isEmpty(poi)) return null;
    const address = poi.where ? (poi.where.address ? poi.where.address : '') : '';
    let latLon = poi.where ? (poi.where.latLon ? poi.where.latLon : {}) : {};
    if (!isEmpty(this.state.latLng)) {
      latLon = this.state.latLng;
    }

    let  showCategory = false;
    if(provider?.enablingStoryboard){
      showCategory  =provider.enablingStoryboard;
    }

    return (
      <Modal open={this.props.isModifying} onClose={this.props.onCloseFunc}>
        <div className={styles.root}>
          <div>
            <div className={styles.fullWidthColumn}>
              <div className={styles.top}>
                <div>
                  <h3>Set Bank</h3>
                </div>
                <div>
                  <CloseIcon className={styles.pointerCursor} onClick={this.props.onCloseFunc} />
                </div>
              </div>
              <div className={styles.middle}>
                <div>
                  <span className={styles.title}>Details</span>
                  <div
                    style={{
                      marginTop: '20px',
                    }}
                  >
                    {showCategory?'': this.renderCategories() }
                    {poi.id && <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" className={styles.adornment}>
                            ID
                          </InputAdornment>
                        ),
                      }}
                      className={styles.textField}
                      value={poi.id}
                      disabled
                    />}
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" className={styles.adornment}>
                            Title
                          </InputAdornment>
                        ),
                      }}
                      className={styles.textField}
                      value={poi.name}
                      onChange={e => this.onChangePOIText('name', e)}
                    />
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment 
                           position="start" 
                           className={styles.adornment}>
                            Information
                          </InputAdornment>
                        ),
                      }}
                      multiline
                      rows="4"
                      className={styles.textField}
                      value={poi.text}
                      onChange={e => this.onChangePOIText('text', e)}
                      placeholder="Brief description of why we recommend this place."
                    />
                    <PlacesAutocomplete
                      value={address}
                      onChange={this.onChangeAddress}
                      onSelect={this.handleSelect}
                    >
                      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div className={styles.placesAutoComplete}>
                          <div className={styles.placesAutoCompleteMain}>
                            <span>Address</span>
                            <input
                              {...getInputProps({
                                placeholder: 'Address, Suburb, State, Country',
                              })}
                            />
                          </div>
                          <div className={styles.placesAutoCompleteSelect}>
                            {loading && <div>Loading...</div>}
                            {suggestions.map(suggestion => {
                              const className = suggestion.active
                                ? styles.suggestionItemActive
                                : styles.suggestionItem;
                              return (
                                <div
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                  })}
                                >
                                  <span>{suggestion.description}</span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>
                  </div>
                </div>
              </div>
              {this.renderMap(latLon)}
              <ACMedia
                name="poiMedia"
                media={media}
                accept="image/*"
                onUploadMediaFunc={this.onUploadPOIMedia}
                isMediaTypeDisabled={true}
              />
              <div className={styles.bottom}>
                <ACButton
                  text={'Save'}
                  icon={<SaveIcon />}
                  iconLast={true}
                  onClickFunc={this.onSavePOI}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
